//import Vue from "vue"

//Vue.filter('capitalize', function (value) {
//    if (!value) return ''
//    value = value.toString()
//    return value.charAt(0).toUpperCase() + value.slice(1)
//})

//Vue.filter('dashesIfNull', function (value) {
//    if (value == 0 && value.length > 0) return value;
//    else if (!value || value.length <= 0) return '-'
//    return value;
//})

//Vue.filter('replaceBreakLine', function (value) {
//    return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
//})


//Vue.filter('dateTime', function (value) {
//    return new Date(value);
//})

//Vue.filter('nullToEmpty', function (value) {
//    return value == null ? '' : value;
//})

//Vue.filter('showBool', function (value) {
//    return value == false ? '' : '<i class="fa fa-check" aria-hidden="true"></i>';
//})

//Vue.filter('showIcon', function (value) {
//    return value.startsWith('fa-') ? '<i class="fa ' + value + '" aria-hidden="true"></i>' : value;
//})

//Vue.filter('toCurrency', function (value) {
//    if (typeof value !== "number") {
//        return value;
//    }
//    var formatter = new Intl.NumberFormat('sv-SE', {
//        style: 'currency',
//        currency: 'SEK',
//        minimumFractionDigits: 0
//    });
//    return formatter.format(value);
//});

//Vue.filter('byteToHumanFormat', function (bytes, si = true) {
//    var thresh = si ? 1000 : 1024;
//    if (Math.abs(bytes) < thresh) {
//        return bytes + ' B';
//    }
//    var units = si
//        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
//        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
//    var u = -1;
//    do {
//        bytes /= thresh;
//        ++u;
//    } while (Math.abs(bytes) >= thresh && u < units.length - 1);

//    return bytes.toFixed(2).replace(".", ",") + ' ' + units[u];
//});
export function capitalize(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function dashesIfNull(value) {
    if (value === 0 && typeof value !== 'undefined') return value;
    if (!value || (typeof value === 'string' && value.length <= 0)) return '-';
    return value;
}

export function replaceBreakLine(value) {
    return value ? value.replace(/(?:\r\n|\r|\n)/g, '<br />') : '';
}

export function dateTime(value) {
    return new Date(value);
}

export function nullToEmpty(value) {
    return value == null ? '' : value;
}

export function showBool(value) {
    return value === false
        ? ''
        : '<i class="fa fa-check" aria-hidden="true"></i>';
}

export function showIcon(value) {
    return value.startsWith('fa-')
        ? '<i class="fa ' + value + '" aria-hidden="true"></i>'
        : value;
}

export function toCurrency(value) {
    if (typeof value !== 'number') return value;

    const formatter = new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        minimumFractionDigits: 0,
    });

    return formatter.format(value);
}

export function byteToHumanFormat(bytes, si = true) {
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) return bytes + ' B';

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);

    return bytes.toFixed(2).replace('.', ',') + ' ' + units[u];
}

